import { UserFormData } from "../types/user.types";
import { RoleSelectionPolicy } from "./userRolePolicy";

const ACTIVE_STATUS = "ACTIVE";

const profileFields = (form: UserFormData) => ({
  firstName: form.firstName.trim(),
  lastName: form.lastName.trim(),
  email: form.email.trim(),
  phone: form.phone
});

/** POST /user body — same shape the legacy register modal sent. */
export const buildRegisterUserPayload = (form: UserFormData, policy: RoleSelectionPolicy) => ({
  ...profileFields(form),
  userRole: policy.toRegisterPayload(form.role),
  status: ACTIVE_STATUS
});

/** PUT /user/:id body — same shape the legacy edit modal sent (single-item role array). */
export const buildUpdateUserPayload = (form: UserFormData) => ({
  ...profileFields(form),
  userRole: form.role ? [form.role] : [],
  status: ACTIVE_STATUS
});
